export const renderNothing = () => null;

export const resolveComponent = (loaderResult) => (loaderResult?.default ? loaderResult.default : loaderResult);
